/*  MUI  */
import { FilterList } from '@mui/icons-material';
import { Badge, IconButton } from '@mui/material';

/*  Shared  */
import { Helpers } from 'application/Shared/Helpers';

/*  NPM  */
import { cloneDeep } from 'lodash';

/*  React  */
import React, { useEffect, useState } from 'react';

import { getShowBadge } from '../helpers';

/* Internal Components */
import { ManagedTableFilterMenu } from './ManagedTableFilterMenu';

/*  Constants  */
const { isset } = Helpers;

export const ManagedTableHeaderFilter = ({
    disabled,
    filters,
    header,
    setFilters,
    setPage
}) => {
    const [filteringHeader, setFilteringHeader] = useState({
        headerOpen: null,
        menuOpen: false
    });

    const filterMenuHandleClick = () => {
        setFilteringHeader({
            headerOpen: { ...header },
            menuOpen: !filteringHeader?.menuOpen
        });
    };

    const updateFilter = () => {
        const currentFilters = filters ? cloneDeep(filters) : {};

        const filterableOptions =
            filteringHeader?.headerOpen?.filterableOptions;
        const filterable = filteringHeader?.headerOpen?.filterable;

        if (filterable && filterableOptions) {
            filterableOptions.forEach((option) => {
                const { parameter, value } = option;

                // If the key is not set, put the default value there
                if (!isset(currentFilters, parameter)) {
                    currentFilters[parameter] = {
                        parameter,
                        showValues: [],
                        values: [],
                        visualValues: []
                    };
                }

                if (!currentFilters[parameter].showValues.includes(value)) {
                    currentFilters[parameter].showValues.push(value);
                }

                // Push the value of the default filter
                if (
                    option.default &&
                    !currentFilters[parameter].values.includes(value)
                ) {
                    currentFilters[parameter].values.push(value);
                }
            });
        }
        return currentFilters;
    };

    useEffect(() => {
        if (header?.filterable && header?.filterableOptions) {
            setFilters(updateFilter());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <IconButton
                data-testid={`managedTableFilterableMenu_${header.component}`}
                data-trackid={`managedTableFilterableMenu_${header.component}`}
                onClick={() => {
                    filterMenuHandleClick();
                }}
                size="small"
                sx={{ color: 'icon.textColor' }}
                variant="slim"
            >
                <Badge
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    badgeContent={
                        getShowBadge({ field: header.field, filters }) ? 1 : 0
                    }
                    color="secondary"
                    disabled={disabled}
                    overlap="rectangular"
                    sx={{
                        // Has to match anchorOrigin above
                        '& .MuiBadge-anchorOriginBottomRight': {
                            bottom: '2px',
                            right: '3px'
                        }
                    }}
                    variant="dot"
                >
                    <FilterList
                        fontSize="small"
                        id={`filterList_${header.field}`}
                    />
                </Badge>
            </IconButton>
            <ManagedTableFilterMenu
                disabled={disabled}
                filteringHeader={filteringHeader}
                filters={filters}
                header={header}
                setFilteringHeader={setFilteringHeader}
                setFilters={setFilters}
                setPage={setPage}
            />
        </>
    );
};
